export default {
  heading: {
    id: 'checkout_bouygues_magic_link_layout_canceled_error_heading',
    defaultMessage: 'La commande du téléphone est annulée',
  },
  firstParagraph: {
    id: 'checkout_bouygues_magic_link_layout_canceled_error_first_paragraph',
    defaultMessage:
      'Vous souhaitez toujours acheter un téléphone avec forfait ? C’est toujours possible en boutique Bouygues Telecom.',
  },
}
